import { isNil as _isNil } from 'lodash';

export default (stringValue?: string): boolean => {
    if (_isNil(stringValue)) {
        return false;
    }

    return /true/i.test(stringValue);
};
